module.exports = __webpack_public_path__ + "static/img/wczd.daaf958.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wczd.png
// module id = YB9c
// module chunks = 0